import { Box, Typography } from "@mui/material";
import { makeStyles } from "components/providers/makeStyles";

const useStyles = makeStyles((theme) => ({
    tableRow: {
        "&&": {
            cursor: "unset",
            "&:hover": {
                background: "unset"
            }
        }
    },
    tableData: {
        borderBottom: "none"
    },
    dashes: {
        width: "100%",
        marginTop: "auto",
        marginBottom: "auto",
        height: theme.spacing(0.25),
        background: `
            radial-gradient(circle closest-side,${theme.palette.brand.tertiary} 98%,#0000) 0 0/${theme.spacing(1)} 100%,
            linear-gradient(90deg,${theme.palette.brand.tertiary} 50%, #0000 0) ${theme.spacing(0.5)} 0/${theme.spacing(2)} 100%
        `,
    },
    cutLineTitle: {
        padding: theme.spacing(0.25, 1),
        backgroundColor: theme.palette.brand.secondary,
        color: theme.palette.brand.tertiary,
        borderRadius: theme.spacing(0.25),
        textTransform: "uppercase",
        flexShrink: "0",
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    box: {
        width: "100%",
        display: "flex",
        direction: "row",
        justifyContent: "center"
    }
}));

export const CutLine = ({ description }) => {
    const classes = useStyles();

    return (
        <tr className={classes.tableRow}>
            <td className={classes.tableData} colSpan={3}>
                <Box className={classes.box}>
                    <Typography className={classes.dashes} />
                    <Typography variant="label2" className={classes.cutLineTitle}>
                        {description}
                    </Typography>
                    <Typography className={classes.dashes} />
                </Box>
            </td>
        </tr>
    );
};
